import { addOrUpdateRule, RuleDefinition } from 'controls/queryBuilder/ruleDefinition';
import { createEmptyCondition } from 'controls/queryBuilder/utils/createEmptyCondition';
import { isConditionComplete } from 'controls/queryBuilder/utils/isConditionComplete';

// the server takes an empty group for false, so one is never put next to a filter
export function combineFilters(base: RuleDefinition | null, filter: RuleDefinition | null) {
	if (!hasRules(base)) {
		return filter;
	}

	if (!hasRules(filter)) {
		return base;
	}

	const result = createEmptyCondition();
	addOrUpdateRule(result, base);
	addOrUpdateRule(result, filter);
	return result;
}

function hasRules(filter: RuleDefinition | null) {
	return filter?.type != null && isConditionComplete(filter);
}
